import { Editor, Node, createEditor } from 'slate';
import { withMarkdownNormalizeNode } from './normalization/normalizeNode';
import { makeTopLevelElement, makeLineElement } from './element-factories';
export const serializeToPlainText = (nodes) => {
    return nodes
        .map((topLevelElement) => topLevelElement.children
        .map((lineElement) => Node.string(lineElement))
        .join('\n'))
        .join('\n');
};
export const deserializeFromPlainText = (text, normalize = true) => {
    const newValue = [
        makeTopLevelElement('paragraph', text.split('\n').map(makeLineElement)),
    ];
    if (!normalize) {
        return newValue;
    }
    const editor = withMarkdownNormalizeNode(createEditor());
    editor.children = newValue;
    Editor.normalize(editor, { force: true });
    const normalizedValue = editor.children;
    return normalizedValue;
};
//# sourceMappingURL=serialize.js.map